import {
  startOfBusinessDayISO,
  endOfBusinessDayISO,
} from "../../functions/timeHandler/bordersOfBusinessDay"

import personCreate from "../../functions/persons/personCreate"
import nodeCreate from "../../functions/nodes/nodeCreate"
import { nodesTreeDownUp } from "../../functions/nodes/nodesAccumulations2"
import addBusinessDays from "date-fns/addBusinessDays"
import isWeekend from "date-fns/isWeekend"
import { ROOT } from "../../const/globals"

export const projectInitialStateSet = () => {
  let theDay = isWeekend(new Date(Date.now()))
    ? addBusinessDays(new Date(Date.now()), 1)
    : new Date(Date.now())

  let _node1 = nodeCreate({
    pId: ROOT,
    fromWhen: startOfBusinessDayISO(theDay, "9"),
    byWhen: endOfBusinessDayISO(theDay, "17"),
  })
  _node1.fromWhenEarliest = _node1.fromWhen

  let _root = nodeCreate({
    nId: ROOT,
    position: [],
    children: [_node1.nId],
    fromWhen: _node1.fromWhen,
    byWhen: _node1.byWhen,
  })
  _root.fromWhenEarliest = _node1.fromWhen

  let setup = {
    communicationTool: "",
    dataRepository: "",
    description: "",
    membersStC: [],
    objective: "",
    membersTeam: [],
    title: "My Project Title",
    // persons
    agileMaster: "",
    controller: "",
    customer1: "",
    customer2: "",
    manager: "",
    otherVIP: "",
    productOwner: "",
    sponsor: "",
    delegateChange: "",
    delegateQuality: "",
    delegateRisk: "",
    delegateKnowledge: "",
    // statusComplete cannot be boolean in order to fill the <Select />
    statusCompleted: "In Progress",
    isStatusLocked: false,
  }

  let ratios = {
    expensesBudget: "",
    expensesActual: "",
    timeBudget: "",
    timeActual: "",
    unresolvedIssues: 0,
    satisfactionCustomer: "",
    satisfactionTeam: "",
    issuesChangeTL: 0,
    issuesChangeCheck: false,
    issuesQualityTL: 0,
    issuesQualityCheck: false,
    issuesRiskTL: 0,
    issuesRiskCheck: false,
    issuesKnowledgeTL: 0,
    issuesKnowledgeCheck: false,
    requests: [],
  }

  let params = {
    hoursPerDay: "8",
    daysPerWeek: "5",
    daysPerMonths: "22",
    dateFormat: "yyyy-MM-dd|HH",
    dayStart: "9",
    dayEnd: "17",
    isDetailsOn: false,
    isSlimOn: false,
    isNameFirstPreferred: true,
    pUnresolvedIssues: [0, 0, 2, 4],
    pDOCThroughDOXS: [0, 90, 95, 100],
    pDOCThroughDOTS: [0, 90, 95, 100],
    pSatisfactionCustomer: [0, 50, 70, 90],
    pSatisfactionTeam: [0, 50, 70, 90],
  }

  let requestsTypical = [
    { value: "_t001", label: "Acknowledge status" },
    { value: "_t002", label: "Add people" },
    { value: "_t003", label: "Announce project, sponsor and project manager" },
    { value: "_t004", label: "Approve additional expenses budget" },
    { value: "_t005", label: "Approve additional time budget" },
    { value: "_t006", label: "Confirm interest in project" },
    { value: "_t007", label: "Clarify priorities" },
    {
      value: "_t008",
      label: "Communicate project, responsibilities & organizational setup",
    },
    { value: "_t009", label: "Empower Project Manager" },
    { value: "_t010", label: "Make overall objective SMART" },
    { value: "_t011", label: "Openly demonstrate commitment" },
    { value: "_t012", label: "Refine objective" },
    { value: "_t013", label: "Resolve conflict" },
    { value: "_t014", label: "Support with external resources" },
    { value: "_t015", label: "Support with IT resources" },
  ]

  let rolesStandard = [
    { value: "customer1", label: "Customer 1" },
    { value: "customer2", label: "Customer 2" },
    { value: "otherVIP", label: "Other VIP" },
    { value: "sponsor", label: "Project Sponsor" },
    { value: "manager", label: "Project Manager" },
    {
      value: "productOwner",
      label: "Product Owner",
    },
    { value: "controller", label: "Project Controller" },
    { value: "agileMaster", label: "Agile Master" },
    { value: "delegateChange", label: "Delegate Change Mgt" },
    { value: "delegateQuality", label: "Delegate Quality Mgt" },
    { value: "delegateRisk", label: "Delegate Risk Mgt" },
    { value: "delegateKnowledge", label: "Delegate Knowledge Mgt" },
    { value: "memberStC", label: "Steering Committee Member" },
    { value: "memberTeam", label: "Team Member" },
  ]

  let project = {
    statuses: {
      [_root.fromWhen]: {
        dId: _root.fromWhen,
        nodes: {
          _root,
          [_node1.nId]: _node1,
        },
        nodeActive: "",
        rows: [ROOT, _node1.nId],
        setup,
        ratios,
        persons: {},
        rolesAdded: [],
        rolesToPersons: [],
        requestsAdded: [],
      },
    },
    statusesList: [_root.fromWhen],
    statusCurrent: _root.fromWhen,
    statusNext: "",
    statusNextPlanned: "",
    params,
    rolesStandard,
    requestsTypical,
    messageFromProject: "",
    isResetForm: false,
  }

  let person = personCreate()
  project.statuses[_root.fromWhen].persons[person.sId] = { ...person }

  project.statuses[_root.fromWhen].nodes = nodesTreeDownUp(
    project.statuses[_root.fromWhen].nodes,
    ROOT,
    _root.fromWhen,
    {
      doPositions: false,
      doDependenciesClean: false,
      doFromByWhens: true,
      doTrafficLights: false,
      doEarliestLatest: true,
    }
  )

  return project
}

let projectInitialState = {
  project: projectInitialStateSet(),
}

export default projectInitialState
